export const FILE_MANAGER_CONTAINER_CLASS_NAME = 'file-manager-container'

export const ARTICULATION_POPUP_CLASS_NAME = 'fm-articulation-popup'

export const RATE_POPUP_CLASS_NAME = 'fm-rate-popup'

export const WINDOW_PATTERN_POPUP_CLASS_NAME = 'fm-window-pattern-popup'

/** 音量暂存: 记录静音前的音量数值 */
export const STASH_VOICE_RECORD_KEY = 'stash_voice'

export const VOICE_RECORD_KEY = 'local_voice'

export const DEFAULT_VOICE = 50

export const MAX_DISTANCE_DIFF = 200

export const HEADER_ITEM_VISIBLE_MIN_WIDTH = 0

export const SHOW_PREVIEW_BAR_MIN_HEIGHT = 390

export const enum PlayMode {
  SINGLE_CIRCULATE = 'SINGLE_CIRCULATE',
  LIST_CIRCULATE = 'LIST_CIRCULATE',
  PAUSE_AFTER_END = 'PAUSE_AFTER_END',
}

export const enum WindowPatternSize {
  FIT_CONTENT = 'FIT_CONTENT',
  KEEP_LONGER = 'KEEP_LONGER',
  KEEP_WIDTH = 'KEEP_WIDTH',
}
